// extracted by mini-css-extract-plugin
module.exports = {"wdpContainer":"WDPSponsorSearch_wdpContainer__3qKpM"};